// src/lib/auth/client.ts
//
// Browser-side Better Auth client for the /account UI. Provides magic-link
// request, Google/GitHub social sign-in, session access, and sign-out.
// API-key CRUD is NOT here — keys live in KV and are managed via /api/account/*
// (see app/account/AccountClient.tsx).
"use client";

import { magicLinkClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  plugins: [magicLinkClient()],
});

export const { signIn, signOut, useSession } = authClient;
